import { Component, OnDestroy, OnInit } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { BsModalRef } from 'ngx-bootstrap/modal';
import { NgxSpinnerService } from 'ngx-spinner';
import { LanguageTranslateService } from 'src/app/_services/language-translate.service';
import { ModalServiceService } from 'src/app/_services/modal-service.service';
import { ErrorUtil } from 'src/app/_utilities/error';
import { SubscriptionUtil } from 'src/app/_utilities/subscription';
import { AuthenticationService } from 'src/app/auth/authentication.service';

@Component({
  selector: 'app-transfer-pdf',
  templateUrl: './transfer-pdf.component.html',
  styleUrl: './transfer-pdf.component.scss',
  standalone: false
})
export class TransferPdfComponent extends SubscriptionUtil implements OnInit, OnDestroy{
  translate: any;
  dateFormat: any;
  dateFormateChange: any;
  data: any;
  safeFileUrl: any;

 constructor(
    public modalRef: BsModalRef,
    private errorUtil: ErrorUtil,
    private spinner: NgxSpinnerService,
    private auth: AuthenticationService,
    private languageTranslateService: LanguageTranslateService,
    private sanitizer: DomSanitizer,
  ) {
    super();
   
  }
  ngOnInit(): void {
    this.dateFormat = localStorage.getItem('date_format');
    this.dateFormateChange = this.auth.getUserTimezone();
 this.getLanguageData();
   

   
  }

  ngOnDestroy(): void {
    super.ngOnDestroy();
  }

   private buildSafeUrl(): void {
    try {
      const url = this.data?.pdfUrl;
      if (url && this.isRemote(url)) {
        // Append PDF viewer params to the raw URL before sanitizing
        const urlWithParams = url + '#toolbar=1&navpanes=0&scrollbar=1&zoom=90';
        this.safeFileUrl = this.sanitizer.bypassSecurityTrustResourceUrl(urlWithParams);
      } else {
        this.safeFileUrl = null;
      }
    } catch (e) {
      console.error('buildSafeUrl error:', e);
      this.safeFileUrl = null;
    }
  }
   isRemote(url?: string | null): boolean {
    return !!(url && (url.startsWith('http://') || url.startsWith('https://')));
  }

  isLocal(url?: string | null): boolean {
    return !!(url && !this.isRemote(url));
  }


  getLanguageData(): void {
    this.push(
      this.languageTranslateService.wordSrc$.subscribe(data => {
        if (Object.keys(data).length !== 0) {
          this.translate = data;

          this.buildSafeUrl();

          
        }
      })
    );
  }
  
  onDownload(): void {
    if (!this.data.pdfUrl) {
      this.errorUtil.setErrorMessage(400, null, 'No file URL available for this PDF', 'error', 3000);
      return;
    }

    const fileName = this.data.fileName || ('PDF-' + this.data.id + '.pdf');

    if (this.data.pdfUrl.startsWith('http://') || this.data.pdfUrl.startsWith('https://')) {
      this.spinner.show();
      fetch(this.data.pdfUrl)
        .then(res => {
          if (!res.ok) throw new Error('Network response was not ok');
          return res.blob();
        })
        .then(blob => {
          const url = window.URL.createObjectURL(blob);
          const a = document.createElement('a');
          a.href = url;
          a.download = fileName;
          a.click();
          window.URL.revokeObjectURL(url);
          this.spinner.hide();
        })
        .catch(() => {
          this.spinner.hide();
          window.open(this.data.pdfUrl!, '_blank', 'noopener,noreferrer');
        });
    } else {
      navigator.clipboard.writeText(this.data.pdfUrl).then(() => {
        this.errorUtil.setErrorMessage(200, 'File path copied to clipboard', null, 'success', 1000);
      });
    }
  }

}
